<template>
	<AssemblyLayout :assembly="assembly" :subtitle="trans('assemblies.representatives.title')">
		<template #actions>
			<PrimaryButton v-if="canUpdate" :color="Color.Green" @click.stop="update">
				<i class="fa-solid fa-check mr-2"/>
				{{ trans('general.confirm') }}
			</PrimaryButton>
		</template>
		<Empty v-if="representatives.length === 0"/>
		<CardGrid v-else>
			<Card v-for="representative in representatives" :key="`period-representative-${representative.id}`" :title="representative.user.full_name">
				<template #badges>
					<Badge :color="representative.color" active>{{ trans(`assemblies.representatives.status.${representative.status}`) }}</Badge>
				</template>
				<LabeledObject>
					<template #label>{{ trans('general.created_at') }}</template>
					<p>{{ dayjs(representative.created_at).format(trans('general.dayjs.datetime')) }}</p>
				</LabeledObject>
				<LabeledObject>
					<template #label>{{ trans('assemblies.representatives.college_zone') }}</template>
					<p>{{ trans(`colleges.${representative.college_zone}`) }}</p>
				</LabeledObject>
				<LabeledObject>
					<template #label>{{ trans('assemblies.representatives.college') }}</template>
					<p>{{ representative.college.name }}</p>
				</LabeledObject>
			</Card>
		</CardGrid>
	</AssemblyLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import dayjs from 'dayjs'
import {route} from 'ziggy-js'
import {ref, type Ref} from 'vue'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/UI/Empty.vue'
import Card from '@/Components/UI/Cards/Card.vue'
import Badge from '@/Components/UI/Badges/Badge.vue'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import AssemblyLayout from '@/Layouts/AssemblyLayout.vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {type Assembly} from '@/Types/Association/Assemblies/Assembly'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'
import {type CollegeZoneRepresentative} from '@/Types/Association/Assemblies/CollegeZoneRepresentative'

const props = defineProps<{
	assembly:Assembly,
	canUpdate:boolean,
	representatives:Array<CollegeZoneRepresentative>,
}>()

const working:Ref<boolean> = ref(false)
const assembly:Ref<Assembly> = ref(props.assembly)
const canUpdate:Ref<boolean> = ref(props.canUpdate)
const representatives:Ref<Array<CollegeZoneRepresentative>> = ref(props.representatives)

function update():void{
	if(!working.value && canUpdate.value && confirm(trans('general.confirm_action'))){
		working.value = true
		showInfo(trans('general.updating'))
		axios.patch(route('association.assemblies.college-zones.representatives.update', assembly.value.id)).then(({data}:{data:Array<CollegeZoneRepresentative>}) => {
			showSuccess(trans('general.updated'))
			representatives.value = data
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>